const playPause = () => {
	const videoTrigger = document?.querySelector(".video__trigger");
	const videoPlayer = document?.querySelector(".video__player");
	if (!videoPlayer && !videoTrigger) {
		return;
	} else {
		videoPlayer.addEventListener("click", () => {
			if (videoPlayer.paused) {
				videoPlayer.play();
				videoTrigger.style.display = "none";
			} else {
				videoTrigger.style.display = "block";
				videoPlayer.pause();
			}
		});
	}
};

export default playPause;
